import { ReactElement } from 'react';

type CalloutProps = {
  title: ReactElement;
  description: ReactElement;
  type: 'secondary' | 'warning' | 'primary';
  onClick: () => void;
  onClose: () => void;
  'data-testid'?: string;
};

export const Callout = ({
  title,
  description,
  type,
  onClick,
  onClose,
  'data-testid': dataTestId,
}: CalloutProps) => {
  return (
    <div
      className={`callout callout-condensed callout-${type} height-100pct
        min-height-90 user-select-none hover-bg-lightest cursor-pointer`}
      onClick={onClick}
      data-testid={dataTestId}
    >
      <button
        data-testid="callout-close-button"
        onClick={(e) => {
          e.stopPropagation();
          onClose();
        }}
        type="button"
        className="btn btn-icon-only close position-absolute top-5 right-5 no-hover-scale"
        data-dismiss="alert"
      >
        <span className="rioglyph rioglyph-remove" />
      </button>
      <div className="display-flex flex-column gap-5 margin-right-15">
        <div className={`text-medium text-color-${type}`}>{title}</div>
        <div>{description}</div>
      </div>
    </div>
  );
};
